import type { IconSvgObject } from './types';

const StickyNote01Icon: IconSvgObject = [
  ["path", { d: "M18.5 5L5.5 5C4.39543 5 3.5 5.89543 3.5 7V20C3.5 21.1046 4.39543 22 5.5 22L18.5 22C19.6046 22 20.5 21.1046 20.5 20V7C20.5 5.89543 19.6046 5 18.5 5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 7.5C11 8.32843 11.6716 9 12.5 9C13.3284 9 14 8.32843 14 7.5V4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7.5 17.5H12.5M7.5 13.5H16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default StickyNote01Icon;
